import React from "react";
import {
  SEO,
  HoursOfOperation,
  Image,
  Location,
  Map,
  InternalLink,
} from "@bluefin/components";
import { Grid, Segment, Button } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class OrderOnlinePage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          ogUrl={"https://bunmeup.com/order-online/"}
        />
        <Grid
          className={"custom-page-order-online custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"xsyqtthyyqafwctj"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"gtheqvymaeaiuhzy"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__e469b91a-4c90-42be-8563-ea1b8392e4db"}
                >
                  <Grid
                    stackable={true}
                    id={"orderOnline"}
                    className={"component-section-container"}
                    textAlign={"center"}
                  >
                    <Grid.Row>
                      <h1>HOURS OF OPERATION</h1>
                      <HoursOfOperation
                        displayOption={"dailyWithPopup"}
                        displayOpenClosedStatus={true}
                        enhancedLabels={{
                          open: "Open now",
                          openingSoon: "Opening soon",
                        }}
                        timezone={fishermanBusiness.primaryLocation.timezone}
                        hours={fishermanBusiness.primaryLocation.hours}
                      />
                    </Grid.Row>
                    <Grid.Row stretched={true}>
                      <Grid.Column width={8} textAlign={"center"}>
                        <Segment padded={"very"} raised={true}>
                          <h1>ORDER FOR PICKUP</h1>
                          <div>
                            <a
                              href={"https://bunmeup.square.site/"}
                              target={"_blank"}
                            >
                              <Image
                                size={"medium"}
                                centered={true}
                                className={"squareLogo"}
                                rounded={true}
                                src={
                                  "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/Square_Logotype_black-055fee9861574695abd75aa53554c448.png"
                                }
                              />
                            </a>
                          </div>
                          <Location
                            businessName={""}
                            phone={null}
                            address={{
                              zip: fishermanBusiness.primaryLocation.zipCode,
                              city: fishermanBusiness.primaryLocation.city,
                              state: fishermanBusiness.primaryLocation.state,
                              street: fishermanBusiness.primaryLocation.street,
                            }}
                          />
                          <Map
                            address={{
                              zip: fishermanBusiness.primaryLocation.zipCode,
                              city: fishermanBusiness.primaryLocation.city,
                              state: fishermanBusiness.primaryLocation.state,
                              street: fishermanBusiness.primaryLocation.street,
                            }}
                          />
                        </Segment>
                      </Grid.Column>
                      <Grid.Column width={8} textAlign={"center"}>
                        <Segment padded={"very"} raised={true}>
                          <h1>ORDER FOR DELIVERY</h1>
                          <div>
                            <Button
                              primary={true}
                              circular={true}
                              size={"massive"}
                              className={"massive-catering-cta"}
                              to={"/catering/"}
                              as={InternalLink}
                            >
                              CATERING
                            </Button>
                          </div>
                          <div>
                            <a
                              href={
                                "https://order.online/business/bun-me-up-12983596"
                              }
                              target={"_blank"}
                            >
                              <Image
                                size={"medium"}
                                className={"doordashLogo"}
                                centered={true}
                                rounded={true}
                                src={
                                  "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/DoorDash-logo_y2MUIbJ-removebg-preview.png"
                                }
                              />
                            </a>
                          </div>
                          <div>
                            <a
                              href={
                                "https://www.order.store/store/bun-me-up/-r4k8fWzXduqYU8OFLiN7Q"
                              }
                              target={"_blank"}
                            >
                              <Image
                                size={"medium"}
                                className={"doordashLogo"}
                                centered={true}
                                rounded={true}
                                src={
                                  "https://fisherman.gumlet.io/public/5eedb6d5-88ab-476e-935a-9d290945e7b7/Uber_Eats_Logo_621Megc-removebg-preview.png"
                                }
                              />
                            </a>
                          </div>
                        </Segment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        timezone
        hours {
          day
          open
          close
          label
        }
        zipCode
        city
        state
        street
      }
    }
    fishermanBusinessWebsitePage(_id: { eq: 28709 }) {
      title
      seoTitle
      description
    }
  }
`;
